import type { CostTypeMapper } from "app/pages/sales-intelligence/modules/quota/types";

import type { AppColumnType } from "../types/rows";

export const appsCostTypeMapper: CostTypeMapper<AppColumnType> = (columnType) => {
    if (columnType === "sdkCategory") {
        return "technologyCategoryField";
    }

    if (columnType === "sdk") {
        return "technologyField";
    }

    return "basicField";
};
